import React, { useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import heroBg from "../assets/hero-01.png";
import { Link } from "react-router-dom";

const categories = ["All", "Split Units", "Cassette Units", "Ducted Systems", "VRF Systems", "Air Curtains", "Accessories"];

const products = [
  { id: 1,  category: "Split Units",    brand: "Hisense", name: "Hisense 1.5HP Inverter Split AC",          model: "AS-12UR4SVETG6",    price: "UGX 1,850,000",  badge: "Best Seller", specs: ["1.5HP / 12,000 BTU", "Inverter Technology", "R32 Refrigerant", "WiFi Control"] },
  { id: 2,  category: "Split Units",    brand: "LG",      name: "LG 2HP Dual Inverter Split AC",             model: "S4-W18KL3WA",       price: "UGX 2,600,000",  badge: "Energy Saver", specs: ["2HP / 18,000 BTU", "Dual Inverter", "5-Star Rating", "Auto Cleaning"] },
  { id: 3,  category: "Split Units",    brand: "Samsung", name: "Samsung 1HP Wind-Free Split AC",            model: "AR09AXKAAWK",       price: "UGX 1,650,000",  badge: null, specs: ["1HP / 9,000 BTU", "Wind-Free Cooling", "AI Auto Mode", "Tri-Care Filter"] },
  { id: 4,  category: "Split Units",    brand: "Midea",   name: "Midea 2.5HP Inverter Split AC",             model: "MSAG-24HRN1-QRD0", price: "UGX 2,950,000",  badge: null, specs: ["2.5HP / 24,000 BTU", "Inverter Compressor", "R410A Refrigerant", "Auto Restart"] },
  { id: 5,  category: "Split Units",    brand: "Gree",    name: "Gree 1HP Lomo Inverter AC",                 model: "GWH09AAD-K6DNA1A", price: "UGX 1,480,000",  badge: "New Arrival", specs: ["1HP / 9,000 BTU", "Inverter", "I-Feel Function", "Quiet Mode"] },
  { id: 6,  category: "Split Units",    brand: "Chiq",    name: "Chiq 1.5HP Smart Inverter AC",              model: "CSA-12DB",          price: "UGX 1,550,000",  badge: null, specs: ["1.5HP / 12,000 BTU", "Smart Inverter", "App Control", "Self-Cleaning"] },
  { id: 7,  category: "Cassette Units", brand: "LG",      name: "LG 2HP Ceiling Cassette AC",                model: "UT24F.NP0",         price: "UGX 4,200,000",  badge: "Commercial", specs: ["2HP / 18,000 BTU", "4-Way Airflow", "Auto Swing", "360° Air Distribution"] },
  { id: 8,  category: "Cassette Units", brand: "Trane",   name: "Trane 3HP Cassette Unit",                   model: "TTK336G100A0",      price: "UGX 6,800,000",  badge: "Premium", specs: ["3HP / 30,000 BTU", "Inverter Driven", "Auto Diagnosis", "Wireless Remote"] },
  { id: 9,  category: "Cassette Units", brand: "Midea",   name: "Midea 2.5HP 4-Way Cassette",               model: "MCD-24HFN8-QRD0",  price: "UGX 4,950,000",  badge: null, specs: ["2.5HP / 24,000 BTU", "4-Way Blow", "LED Panel", "Auto Restart"] },
  { id: 10, category: "Ducted Systems", brand: "Trane",   name: "Trane 5HP Ducted System",                   model: "TTA060F300A0",      price: "UGX 14,500,000", badge: "Premium", specs: ["5HP / 60,000 BTU", "Concealed Install", "Central Control", "HEPA Filtration"] },
  { id: 11, category: "Ducted Systems", brand: "LG",      name: "LG 4HP Duct Air Handler",                   model: "UT42W.NM0",         price: "UGX 11,200,000", badge: null, specs: ["4HP / 42,000 BTU", "Low Static", "Multi-Zone", "BMS Compatible"] },
  { id: 12, category: "VRF Systems",    brand: "Trane",   name: "Trane VRF 8HP Outdoor Unit",                model: "TVA080KA30FB",      price: "UGX 28,000,000", badge: "Enterprise", specs: ["8HP / 80,000 BTU", "Variable Refrigerant Flow", "Up to 16 Indoor Units", "BMS Integration"] },
  { id: 13, category: "VRF Systems",    brand: "LG",      name: "LG Multi V 10HP VRF",                       model: "ARUM100LTE5",       price: "UGX 34,500,000", badge: "Enterprise", specs: ["10HP / 100,000 BTU", "Heat Recovery", "Smart HVAC Solution", "Up to 20 Indoor Units"] },
  { id: 14, category: "Air Curtains",   brand: "Hisense", name: "Hisense 1.2m Air Curtain",                  model: "HAC-120T",          price: "UGX 980,000",    badge: null, specs: ["1200mm Width", "Centrifugal Fan", "Low Noise", "Easy Install"] },
  { id: 15, category: "Air Curtains",   brand: "Midea",   name: "Midea 1.5m Heated Air Curtain",             model: "EFS-150T",          price: "UGX 1,350,000",  badge: null, specs: ["1500mm Width", "Heating Function", "3-Speed Control", "Remote Included"] },
  { id: 16, category: "Accessories",    brand: "Generic", name: "AC Copper Pipe 1/4\" x 1/2\" (per metre)", model: "CU-0412",           price: "UGX 18,500",     badge: null, specs: ["1/4\" & 1/2\" Pair", "Insulated", "Per Metre", "All Brands Compatible"] },
  { id: 17, category: "Accessories",    brand: "Generic", name: "AC Stabilizer 3000W",                       model: "STB-3000",          price: "UGX 185,000",    badge: null, specs: ["3000W Capacity", "Voltage Protection", "Auto Reset", "LED Display"] },
  { id: 18, category: "Accessories",    brand: "Generic", name: "WiFi Smart AC Controller",                  model: "WF-CTL-01",         price: "UGX 145,000",    badge: "New", specs: ["Universal Compatible", "App Control", "Voice Assistant", "Schedule Timer"] },
];

const badgeColors = {
  "Best Seller": { bg: "#00C7EF", text: "#0F1030" },
  "Energy Saver": { bg: "#22c55e", text: "#fff" },
  "New Arrival": { bg: "#f59e0b", text: "#fff" },
  "New": { bg: "#f59e0b", text: "#fff" },
  "Commercial": { bg: "#8b5cf6", text: "#fff" },
  "Premium": { bg: "#0F1030", text: "#00C7EF" },
  "Enterprise": { bg: "#0F1030", text: "#00C7EF" },
};

export default function SmartStoresPage() {
  const [activeCategory, setActiveCategory] = useState("All");
  const [search, setSearch] = useState("");

  const filtered = products.filter((p) => {
    const matchCat = activeCategory === "All" || p.category === activeCategory;
    const matchSearch =
      search.trim() === "" ||
      p.name.toLowerCase().includes(search.toLowerCase()) ||
      p.brand.toLowerCase().includes(search.toLowerCase()) ||
      p.model.toLowerCase().includes(search.toLowerCase());
    return matchCat && matchSearch;
  });

  return (
    <motion.div
      className="font-poppins"
      initial={{ opacity: 0, y: 30 }}
      animate={{ opacity: 1, y: 0 }}
      exit={{ opacity: 0, y: -20 }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >

      {/* ── HERO BANNER ── */}
      <section className="relative min-h-[300px] sm:min-h-[380px] lg:min-h-[450px] flex items-center justify-center text-white overflow-hidden">
        <div className="absolute inset-0 bg-cover bg-center bg-no-repeat" style={{ backgroundImage: `url(${heroBg})` }} />
        <div className="absolute inset-0" style={{ backgroundColor: "rgba(0, 199, 239, 0.55)" }} />
        <div className="relative text-center px-4 sm:px-8 lg:px-16 py-14 sm:py-20">
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4" style={{ textShadow: "2px 2px 8px rgba(0,0,0,0.8)" }}>
            Smart Stores
          </h1>
          <p className="text-base sm:text-xl font-semibold uppercase tracking-widest max-w-2xl mx-auto text-white leading-snug" style={{ textShadow: "1px 1px 6px rgba(0,0,0,0.9)" }}>
            Premium HVAC Equipment — Sourced, Supplied & Installed
          </p>
        </div>
      </section>

      {/* ── STORE BODY ── */}
      <section className="bg-gray-50 py-10 sm:py-14">
        <div className="max-w-6xl mx-auto px-4 sm:px-6">

          {/* Search + result count — slides down */}
          <motion.div
            className="flex flex-col sm:flex-row gap-4 mb-8 items-start sm:items-center justify-between"
            initial={{ opacity: 0, y: -30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.5 }}
            transition={{ duration: 0.5, ease: "easeOut" }}
          >
            <div className="relative w-full sm:w-72">
              <svg className="absolute left-3 top-1/2 -translate-y-1/2 w-4 h-4 text-gray-400" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" d="M21 21l-4.35-4.35M17 11A6 6 0 1 1 5 11a6 6 0 0 1 12 0z" />
              </svg>
              <input
                type="text"
                placeholder="Search by brand, name or model..."
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                className="w-full pl-9 pr-4 py-2.5 text-sm border-2 outline-none focus:border-cyan-400 rounded-none bg-white"
                style={{ borderColor: "#0F1030" }}
              />
            </div>
            <p className="text-xs text-gray-500 font-medium">
              Showing <span className="font-bold" style={{ color: "#0F1030" }}>{filtered.length}</span> product{filtered.length !== 1 ? "s" : ""}
            </p>
          </motion.div>

          {/* Category pills — each pops in one by one */}
          <div className="flex flex-wrap gap-2 mb-8">
            {categories.map((cat, i) => (
              <motion.button
                key={cat}
                onClick={() => setActiveCategory(cat)}
                className="px-4 py-1.5 text-xs sm:text-sm font-bold tracking-wide border-2 transition-colors duration-150"
                style={{
                  borderColor: "#0F1030",
                  backgroundColor: activeCategory === cat ? "#0F1030" : "transparent",
                  color: activeCategory === cat ? "#00C7EF" : "#0F1030",
                }}
                initial={{ opacity: 0, scale: 0.8 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true, amount: 0.5 }}
                transition={{ duration: 0.3, ease: "easeOut", delay: i * 0.06 }}
                whileTap={{ scale: 0.95 }}
              >
                {cat}
              </motion.button>
            ))}
          </div>

          {/* Product grid — cards stagger in, re-animates on filter change */}
          {filtered.length === 0 ? (
            <motion.div
              className="text-center py-20 text-gray-400 text-sm"
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              transition={{ duration: 0.4 }}
            >
              No products found. Try a different search or category.
            </motion.div>
          ) : (
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6">
              <AnimatePresence mode="popLayout">
                {filtered.map((p, i) => (
                  <motion.div
                    key={p.id}
                    layout
                    className="bg-white border-2 flex flex-col group"
                    style={{ borderColor: "#e5e7eb" }}
                    initial={{ opacity: 0, y: 50 }}
                    animate={{ opacity: 1, y: 0 }}
                    exit={{ opacity: 0, scale: 0.95 }}
                    transition={{ duration: 0.4, ease: "easeOut", delay: i * 0.05 }}
                  >
                    {/* Image placeholder */}
                    <div
                      className="h-44 flex items-center justify-center relative overflow-hidden"
                      style={{ backgroundColor: "#0F1030" }}
                    >
                      {p.badge && (
                        <span
                          className="absolute top-3 left-3 text-xs font-bold px-2.5 py-1 tracking-wide"
                          style={{
                            backgroundColor: badgeColors[p.badge]?.bg ?? "#00C7EF",
                            color: badgeColors[p.badge]?.text ?? "#0F1030",
                          }}
                        >
                          {p.badge}
                        </span>
                      )}
                      <div className="text-center">
                        <p className="text-5xl font-extrabold tracking-widest opacity-20 select-none" style={{ color: "#00C7EF" }}>
                          {p.brand.toUpperCase().slice(0, 4)}
                        </p>
                        <p className="text-white text-xs opacity-40 mt-1 tracking-widest">{p.model}</p>
                      </div>
                      <div
                        className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-opacity duration-200"
                        style={{ backgroundColor: "rgba(0,199,239,0.15)" }}
                      >
                        <Link
                          to="/contact"
                          className="text-xs font-bold px-5 py-2 tracking-wide"
                          style={{ backgroundColor: "#00C7EF", color: "#0F1030" }}
                        >
                          ENQUIRE NOW
                        </Link>
                      </div>
                    </div>

                    {/* Card body */}
                    <div className="p-4 flex flex-col flex-1">
                      <p className="text-xs font-bold tracking-widest mb-1" style={{ color: "#00C7EF" }}>
                        {p.brand} · {p.category}
                      </p>
                      <h3 className="font-bold text-sm sm:text-base leading-snug mb-2" style={{ color: "#0F1030" }}>
                        {p.name}
                      </h3>
                      <ul className="flex flex-wrap gap-1.5 mb-4">
                        {p.specs.map((s) => (
                          <li key={s} className="text-xs px-2 py-0.5 font-medium" style={{ backgroundColor: "#f3f4f6", color: "#374151" }}>
                            {s}
                          </li>
                        ))}
                      </ul>
                      <div className="mt-auto flex items-center justify-between gap-3">
                        <p className="font-extrabold text-sm sm:text-base" style={{ color: "#0F1030" }}>
                          {p.price}
                        </p>
                        <Link
                          to="/contact"
                          className="text-xs font-bold px-4 py-2 tracking-wide whitespace-nowrap transition-colors duration-150"
                          style={{ backgroundColor: "#0F1030", color: "#ffffff" }}
                          onMouseEnter={e => { e.currentTarget.style.backgroundColor = "#00C7EF"; e.currentTarget.style.color = "#0F1030"; }}
                          onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#0F1030"; e.currentTarget.style.color = "#ffffff"; }}
                        >
                          GET QUOTE
                        </Link>
                      </div>
                    </div>
                  </motion.div>
                ))}
              </AnimatePresence>
            </div>
          )}

          {/* Bottom CTA — fades up */}
          <motion.div
            className="mt-12 py-10 px-6 text-center"
            style={{ backgroundColor: "#0F1030", border: "2px solid #00C7EF" }}
            initial={{ opacity: 0, y: 40 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true, amount: 0.4 }}
            transition={{ duration: 0.6, ease: "easeOut" }}
          >
            <p className="text-white text-sm sm:text-base mb-1 font-medium">Don't see what you're looking for?</p>
            <h3 className="text-xl sm:text-2xl font-extrabold mb-5" style={{ color: "#00C7EF" }}>
              We Source Any HVAC Brand or Model
            </h3>
            <Link
              to="/contact"
              className="inline-block font-bold px-8 py-3 text-sm tracking-wide transition-colors duration-150"
              style={{ backgroundColor: "#00C7EF", color: "#0F1030" }}
              onMouseEnter={e => { e.currentTarget.style.backgroundColor = "#ffffff"; e.currentTarget.style.color = "#0F1030"; }}
              onMouseLeave={e => { e.currentTarget.style.backgroundColor = "#00C7EF"; e.currentTarget.style.color = "#0F1030"; }}
            >
              CONTACT US TO ORDER
            </Link>
          </motion.div>

        </div>
      </section>
    </motion.div>
  );
}